import { render, staticRenderFns } from "./abount.vue?vue&type=template&id=42f3bc0e&scoped=true"
import script from "./abount.vue?vue&type=script&lang=js"
export * from "./abount.vue?vue&type=script&lang=js"
import style0 from "./abount.vue?vue&type=style&index=0&id=42f3bc0e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f3bc0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/whitewe_jisheng-mes-ui_CPvN/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42f3bc0e')) {
      api.createRecord('42f3bc0e', component.options)
    } else {
      api.reload('42f3bc0e', component.options)
    }
    module.hot.accept("./abount.vue?vue&type=template&id=42f3bc0e&scoped=true", function () {
      api.rerender('42f3bc0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/abount.vue"
export default component.exports